import { axios } from "../../util/axiosConfig";
import { account } from "../urls";

const passwordReset = (token, newPassword) =>
  axios.post(account.passwordReset, { token, newPassword }).then(response => response.data);

export default passwordReset;
